import script from "./GodApeQuestWalletItemIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestWalletItemIngredients.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestWalletItemIngredients.vue?vue&type=style&index=0&id=0af87e67&lang=scss"

const __exports__ = script;

export default __exports__